import React from 'react';
import { Helmet } from 'react-helmet';
import { Link, useNavigate } from 'react-router-dom';

export default function FansQuestion() {
    const navigate = useNavigate();

    return (
        <>
            <Helmet>
                <title> Dashboard</title>
            </Helmet>

            {/* start: fans-wanna-know page */}
            <div className="main-body">
                <div className="main-header-s1 center-text">
                    <button type="button" className="back-btn" onClick={() => navigate(-1)}>
                        <img src="/images/icons/chevron-left.svg" alt="" />
                    </button>
                    <h1>Fans wanna know</h1>
                    <button type="button" className="transparent-btn">
                        <img src="/images/icons/info.svg" alt="" />
                    </button>
                </div>
                <div className="body-content">
                    <div className="body-sub-header-filter-s1">
                        <h3>All Questions</h3>
                        <div className="right-filters">
                            <div className="filter-li w-100px">
                                <select name="" id="" className="form-control select1">
                                    <option value="">Newest</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    {/* <div className="coming-soon-wrap" style={{ width: '100%' }}>
                        <div className="blur-content" > */}
                    {[1, 2, 3, 4].map((item, index) =>
                    (
                        <div className="questions-lists mt-2">
                            <div className="questions-item">
                                <div className="questions-box">
                                    <div className="questions-information">
                                        <div className="title-with-status">
                                            <h4>Do you have any pets</h4>
                                            <div className="status-div pending">
                                                <span className="icon">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width={14}
                                                        height={14}
                                                        viewBox="0 0 14 14"
                                                        fill="none"
                                                    >
                                                        <path
                                                            d="M12.25 7C12.25 8.03835 11.9421 9.05339 11.3652 9.91674C10.7883 10.7801 9.9684 11.453 9.00909 11.8504C8.04978 12.2477 6.99418 12.3517 5.97578 12.1491C4.95738 11.9466 4.02192 11.4465 3.28769 10.7123C2.55347 9.97809 2.05345 9.04262 1.85088 8.02422C1.64831 7.00582 1.75227 5.95022 2.14963 4.99091C2.54699 4.0316 3.2199 3.21166 4.08326 2.63478C4.94662 2.05791 5.96165 1.75 7 1.75C8.47 1.75 9.87584 2.33333 10.9317 3.34833L12.25 4.66667"
                                                            stroke="black"
                                                            strokeWidth="1.2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            d="M12.25 1.75V4.66667H9.33331"
                                                            stroke="black"
                                                            strokeWidth="1.2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                </span>
                                                <span className="text">Pending</span>
                                            </div>
                                        </div>
                                        <div className="more-texts">
                                            <span>Asked by</span>
                                            <b>@user_name12</b>
                                        </div>
                                    </div>
                                    <div className="questions-actions">
                                        <button type="button" className="gray-btn">
                                            <span className="icon">
                                                <img src="/images/message-circle-more.svg" alt="" />
                                            </span>
                                            <span className="text">Text Reply</span>
                                        </button>
                                        <button type="button" className="gray-btn gradient-btn">
                                            <span className="icon">
                                                <img src="/images/mic-white.svg" alt="" />
                                            </span>
                                            <span className="text">Voice</span>
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    )
                    )}

                    {/* </div>
                        <div className="coming-soon-badge">Coming Soon</div>
                    </div> */}
                </div>
                {/* <div className="bottom-cpx-text">Metrics update every 24 hours.</div> */}
            </div>

            {/* end: fans-wanna-know page */}
        </>
    );
}

